import { render, staticRenderFns } from "./supportProducts.vue?vue&type=template&id=81f92d7c&scoped=true&"
import script from "./supportProducts.vue?vue&type=script&lang=js&"
export * from "./supportProducts.vue?vue&type=script&lang=js&"
import style0 from "./supportProducts.vue?vue&type=style&index=0&id=81f92d7c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81f92d7c",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/alibaba/product/components/supportProducts.vue
// module id = null
// module chunks = 